import "./stylesheets/app.scss";
import React, {Component} from "react";
import {BrowserRouter as Router} from "react-router-dom";
import Loadable from "react-loadable";
import Preloader from "./components/Preloader";
import { ComponentBase } from '@syncfusion/ej2-react-base';
import { GridComponent } from '@syncfusion/ej2-react-grids';
import { TreeGridComponent } from "@syncfusion/ej2-react-treegrid";
//import { L10n } from '@syncfusion/ej2-base';
import { findDOMNode } from 'react-dom';
import { Tooltip } from '@syncfusion/ej2-popups';
import {NotificationContextProvider} from "./contexts/notification/Context";
import {TeamsContextProvider} from "./contexts/team/Context";

const DefaultLayout = Loadable({
  loading: Preloader,
  loader: () => import("./containers/DefaultLayout"),
});

class App extends Component {
  constructor() {
    super();

    // componentWillUnmount will throw error , catch it
    ComponentBase.prototype.componentWillUnmountOrig = ComponentBase.prototype.componentWillUnmount

    ComponentBase.prototype.componentWillUnmount = function () {
      try {
        console.log('i die')
        this.componentWillUnmountOrig()
      } catch (e) {
        console.log('RI not P', e)
      }

    }

    const l = [ GridComponent.prototype,TreeGridComponent.prototype ];
    l.forEach(pt =>{

      pt.showSpinnerOrig =  pt.showSpinner
      pt.hideSpinnerOrig =  pt.hideSpinner
      pt.componentDidMountOrig =  pt.componentDidMount
      pt.componentWillUnmountOrig = pt.componentWillUnmount



      pt.componentDidMount = function() {
        if (this.props.cpOverrideLoading !== undefined && this.cpOverrideLoading == undefined){
          this.cpOverrideLoading = this.props.cpOverrideLoading
        }
        setTimeout(() => {
          const el = findDOMNode(this)
          this.cpObserver = new MutationObserver((mutationsList, obs) => {
            if (this.cpOverrideLoading !== undefined){
              const addedNodes = mutationsList.flatMap(x => [...x.addedNodes]).filter(x=>x.classList)
              if (addedNodes.length){
                this.cpSetLoading(this.cpOverrideLoading)

              }



            }

          })
          this.cpObserver.observe(el, {childList: true, subtree: true})


        }, 0);
        this.componentDidMountOrig()

      }
      pt.componentWillUnmount = function () {

        if(this.cpObserver){
          this.cpObserver.disconnect()
        }
        this.componentWillUnmountOrig()

      }

      pt.cpSetLoading = function(isLoading) {
        try{
          const el = findDOMNode(this)
          if (!el){
            return
          }
          const td =  el.querySelector(".e-table .e-emptyrow td");
          if (td){
            td.innerText =  isLoading ? "Loading in progress..." : (this.props?.noRecordMessage || "No records to display")
          }

        }catch(e){

        }


      }

      pt.showSpinner  = function () {
        if (this.cpOverrideLoading === undefined){
          this.cpSetLoading(true)
        }
        this.showSpinnerOrig()

      }
      pt.hideSpinner  = function () {
        if (this.cpOverrideLoading === undefined){
          this.cpSetLoading(false)
        }
        this.hideSpinnerOrig()
      }
      pt.cpOverrideLoadingStart = function () {
        this.cpOverrideLoading = true;
        this.cpSetLoading(true);
      }
      pt.cpOverrideLoadingEnd = function () {
        this.cpOverrideLoading = false;
        this.cpSetLoading(false);

      }
      pt.cpOverrideLoadingUnSet = function (isLoading) {
        this.cpOverrideLoading = undefined;
        setTimeout(() => {
          this.cpSetLoading(isLoading);

        }, 0);


      }




    })


  }
  isEllipsisActive( el ) {
    try{
      return el.scrollWidth !== el.offsetWidth ?
      el.scrollWidth > el.offsetWidth :
      this.checkRanges( el ); // Blink and Webkit browsers do floor scrollWidth
    }catch(e){
      return false
    }

  }

  checkRanges( el ) {
    const range = new Range();
    range.selectNodeContents( el );

    const range_rect = range.getBoundingClientRect();
    const el_rect = el.getBoundingClientRect();
    const style = window.getComputedStyle(el);
    const innerWidth = ['paddingRight', 'paddingLeft', 'textIndent'].map(x => parseInt(style[x].replace('px',''))).reduce((a,b) => a+b, 0)
    return (range_rect.width + innerWidth) > el_rect.width;
  }

  componentDidMount(){

    this.tooltipClose =  () =>  {
      this.tooltip.close()
    }

    this.tooltip = new Tooltip({
      beforeRender: (args) => {
        const target = args?.target;
        if ( target.textContent && this.isEllipsisActive(target) ){


          this.tooltip.content = target.textContent ;
          this.tooltip.dataBind();



        }else{
          args.cancel = true;
        }

      },
      afterOpen: (args) =>{
        this.tooltipListener = args.element.addEventListener("mouseenter",this.tooltipClose, false);
      },
      beforeClose: (args) =>{
        if (args?.element!==undefined && args?.element!==null){
          args.element.removeEventListener("mouseenter",this.tooltipClose);
        }
      },
      content: 'Loading...',
      position: 'TopCenter',
      target: '.e-list-item'
    });
    this.tooltip.appendTo('body');


  }

  render() {
    return (
      <Router>
          <NotificationContextProvider>
              <TeamsContextProvider>
                  <DefaultLayout/>
              </TeamsContextProvider>
          </NotificationContextProvider>
      </Router>
    );
  }
}

export default App;
